const elections = {
  en: {
    electionsPage: {
      title: "Elections",
      subtitle: "View and manage all election types",
      selectTypePlaceholder: "Select Election Type",
      refresh: "Refresh",
      shareTitle: "EReMS Cameroon - {{label}} Election Results",
      shareText: "🗳️ {{label}} Elections in Cameroon!",
      fullManagement: "Full Management",
      totalVotes: "Total Votes",
      validVotes: "Valid Votes",
      rejectedVotes: "Rejected Votes",
      stationsReported: "Stations Reported",
      constituenciesReported: "Constituencies Reported",
      regionsReported: "Regions Reported",
      councilsReported: "Councils Reported",
      areasReported: "Areas Reported",
      projectedWinner: "Projected Winner",
      leadingParty: "Leading Party",
      votesCount: "{{count}} votes",
      tabOverview: "Overview",
      tabCandidates: "Candidates ({{count}})",
      tabResults: "Results ({{count}})",
      candidateResults: "Candidate Results",
      partyResults: "Party Results",
      noResultsData: "No results data available",
      voteDistribution: "Vote Distribution",
      noData: "No data available",
      national: "National",
      noCandidates: "No candidates registered",
      submittedOn: "{{division}} • Submitted {{date}}",
      validCount: "{{count}} valid",
      showingFirst: "Showing first 50 of {{count}} results",
      noResultsSubmitted: "No results submitted",
      unknown: "Unknown",
      status: {
        approved: "approved",
        certified: "certified",
        pending: "pending",
        rejected: "rejected",
        disputed: "disputed",
        verified: "verified",
        submitted: "submitted"
      },
      types: {
        presidential: {
          label: "Presidential",
          description: "National scope • All 10 regions"
        },
        parliamentary: {
          label: "Parliamentary",
          description: "180 Constituencies • Proportional"
        },
        senatorial: {
          label: "Senatorial",
          description: "10 Regions • 70 seats"
        },
        regional: {
          label: "Regional",
          description: "NW & SW only • Special status"
        },
        council: {
          label: "Council",
          description: "357 Councils • Local level"
        }
      }
    }
  },
  fr: {
    electionsPage: {
      title: "Élections",
      subtitle: "Consultez et gérez tous les types d'élections",
      selectTypePlaceholder: "Sélectionnez un type d'élection",
      refresh: "Actualiser",
      shareTitle: "EReMS Cameroon - Résultats de l'élection {{label}}",
      shareText: "🗳️ Élections {{label}} au Cameroun !",
      fullManagement: "Gestion complète",
      totalVotes: "Total des votes",
      validVotes: "Votes valides",
      rejectedVotes: "Votes rejetés",
      stationsReported: "Bureaux de vote ayant transmis",
      constituenciesReported: "Circonscriptions ayant transmis",
      regionsReported: "Régions ayant transmis",
      councilsReported: "Communes ayant transmis",
      areasReported: "Zones ayant transmis",
      projectedWinner: "Vainqueur projeté",
      leadingParty: "Parti en tête",
      votesCount: "{{count}} voix",
      tabOverview: "Aperçu",
      tabCandidates: "Candidats ({{count}})",
      tabResults: "Résultats ({{count}})",
      candidateResults: "Résultats des candidats",
      partyResults: "Résultats des partis",
      noResultsData: "Aucune donnée de résultats disponible",
      voteDistribution: "Répartition des voix",
      noData: "Aucune donnée disponible",
      national: "National",
      noCandidates: "Aucun candidat enregistré",
      submittedOn: "{{division}} • Soumis le {{date}}",
      validCount: "{{count}} valides",
      showingFirst: "Affichage des 50 premiers sur {{count}} résultats",
      noResultsSubmitted: "Aucun résultat soumis",
      unknown: "Inconnu",
      status: {
        approved: "approuvé",
        certified: "certifié",
        pending: "en attente",
        rejected: "rejeté",
        disputed: "contesté",
        verified: "vérifié",
        submitted: "soumis"
      },
      types: {
        presidential: {
          label: "Présidentielle",
          description: "Portée nationale • Les 10 régions"
        },
        parliamentary: {
          label: "Législative",
          description: "180 circonscriptions • Proportionnelle"
        },
        senatorial: {
          label: "Sénatoriale",
          description: "10 régions • 70 sièges"
        },
        regional: {
          label: "Régionale",
          description: "NO et SO uniquement • Statut spécial"
        },
        council: {
          label: "Municipale",
          description: "357 communes • Niveau local"
        }
      }
    }
  }
};

export default elections;
